import * as h from "../helpers/helpers";
import * as scf from '../data/salesComparisonFunctions';

export function GetDataSourcesList(relationship, label) {
	var value = [];
	var rels = global.ptr.relationships.GetRelationshipsTo(relationship, label);
	for (var rel of rels) {
		var dataSource = global.ptr.valuationAnalysis.dataSources.GetDataSourceType(rel);
		value.push(dataSource);
	}
	return value;
}

export function GetDataSources(relationship, label) {
	var sources = "";
	var rels = global.ptr.relationships.GetRelationshipsTo(relationship, label);
	for (var rel of rels) {
		var dataSource = global.ptr.valuationAnalysis.dataSources.GetDataSourceType(rel);
		sources = h.addWithNewline(sources, dataSource);
	}
	return sources;
}

export function SiteInfluencesList() {
	var value = [];
	var row =[];
	// environmental conditions
	var conditions = global.ptr.subProp.environmentalConditions;
	if (conditions !== null) {
		for (var c of conditions) {
			var iType = c.GetConditionType();
			if (iType !== "None") {
				row = [];
				row.push("Apparent Environmental\nCondition");
				row.push(c.GetProximity());
				row.push(iType);
				row.push(h.toEnumText(c.valueMarketabilityImpactType));
				row.push(c.environmentalConditionIdentifiedDescription);
				value.push(row);
			}
		}
	}
	var sinf = global.ptr.subSite.siteInfluences;
	if (sinf !== null) {
		//console.log(sinf);
		// regular influences
		for (var influence of sinf)	{
			var influenceDetail = influence.siteInfluenceDetail;
			if (influenceDetail.siteInfluenceType === "BodyOfWater") continue;
			row = [];
			row.push(influence.GetInfluenceType());
			row.push(h.toEnumText(influenceDetail.siteInfluenceProximityType));
			row.push("");
			row.push(h.toEnumText(influenceDetail.valueMarketabilityImpactType));
			row.push(influenceDetail.siteInfluenceDescription);
			value.push(row);
		}
		// bodies of water
		for (influence of sinf)	{
			influenceDetail = influence.siteInfluenceDetail;
			if (influenceDetail.siteInfluenceType !== "BodyOfWater") continue;
			for (var bow of influence.bodiesOfWater.bodyOfWaterList)	{
				row = [];
				row.push(influence.GetInfluenceType());
				row.push(h.toEnumText(bow.bodyOfWaterProximityType));
				row.push(bow.GetBodyType());
				row.push(h.toEnumText(influenceDetail.valueMarketabilityImpactType));
				row.push(bow.bodyOfWaterDescription);
				value.push(row);
			}
		}
	}
	return value;
}

export function ViewAndImpactList() {
	let value = [];

	var views = global.ptr.subSite.siteViews;
	if (views !== null)
		var numViews = global.ptr.subSite.siteViews.count;
		for (var view of views) {
			let row =[];
			var type = view.GetViewType(numViews);
			if (view.viewPrimaryIndicator) type += " (Primary)"
			row.push(type);
			row.push(view.GetViewRange());
			row.push(view.valueMarketabilityImpactType);
			value.push(row);
		}

	return value;
}

export function SiteFeaturesImpactList() {
		var value = [];
		var row = [];
		// Non-Residential Property Use
		var nonResUses = global.ptr.subProp.GetNonResidentialUses();
		//console.log("nonRes: ", nonResUses);
		if (!h.isEmpty(nonResUses))
		{
			var impact = "";
			var nrcomment = "";
			var bMixedUse = global.ptr.subProp.propertyUseSummary.propertyMixedUsageIndicator ?? false;
			if (bMixedUse) {
				impact = global.ptr.valRpt.GetValuationImpact("PropertyNonResidentialUses");
				nrcomment = global.ptr.valRpt.GetValuationCommentaryText("PropertyNonResidentialUses");
			}
			row = [];
			row.push("Non-Residential Property Use");
			row.push(nonResUses);
			row.push(impact);
			row.push(nrcomment);
			value.push(row);
		}

		// Hazard Zone
		for (var hz of global.ptr.subSite.hazardZones)	{
			var hazardType = hz.GetHazardType();
			//console.log("hz: ", hazardType, hz);
			if (hazardType === "None") hazardType = "No Hazard Zone Noted";
			row = [];
			row.push("Hazard Zone");
			row.push(hazardType);
			row.push(global.ptr.valRpt.GetValuationImpact("HazardZones"));
			row.push(global.ptr.valRpt.GetValuationCommentaryText("HazardZones"));
			value.push(row);
		}

		// Property Restrictions

		var restrictions = global.ptr.subProp.GetEncumbrancesByType("ConditionsCovenantsRestrictions");
		if (restrictions !== null)
			for (var restriction of restrictions)	{
				if (h.isEmpty(restriction.restrictionType)) continue;
				row = [];
				row.push("Property Restriction");
				row.push(restriction.GetCCRType());
				row.push(restriction.valueMarketabilityImpactType);
				row.push(restriction.restrictionDescription);
				value.push(row);
			}

		var easements = global.ptr.subProp.GetEncumbrancesByType("Easements");
		if (easements !== null)
			for (var easement of easements)	{
				row = [];
				row.push("Easement");
				row.push(easement.GetEasementType());
				row.push(easement.valueMarketabilityImpactType);
				row.push(easement.easementDescription);
				value.push(row);
			}

		var encroachments = global.ptr.subProp.GetEncumbrancesByType("");
		if (encroachments !== null)
			for (var encroachment of encroachments)	{
				row = [];
				row.push("Encroachment");
				row.push(encroachment.GetEncroachmentType());
				row.push(encroachment.valueMarketabilityImpactType);
				row.push(encroachment.encroachmentDescription);
				value.push(row);
			}

		var features = global.ptr.subSite.GetFeatures();
		if (features !== null)
			for (var feature of features)	{
				var featureType = feature.GetFeatureType();
				if (featureType === "None") continue;
				row = [];
				row.push("Site Characteristic");
				row.push(featureType);
				row.push(feature.siteFeatureDetail.valueMarketabilityImpactType);
				row.push(feature.GetDescription());
				value.push(row);
			}
			
		return value;
}

export function GetUtilitiesImpactList() {
	var value = [];
	var utils = global.ptr.subSite.siteUtilities;
	//console.log(utils);
	if (utils.length > 0)
		for (var utility of utils)	{
			var utilDetails = utility.siteUtilityDetail;
			var utilDescription = utility.GetDetail();
			var utilImpact = utilDetails.valueMarketabilityImpactType;
			var utilComment = utilDetails.siteUtilityDescription;
			//console.log(utility.isPublic(), utility.isPrivate());
			var row = [];
			row.push(utility.GetUtilityType());
			row.push(h.toChecked(utility.IsPublic()));
			row.push(h.toChecked(utility.IsPrivate()));
			row.push(utilDescription);
			row.push(utilImpact);
			row.push(utilComment);
			value.push(row);
		}

	//console.log(value);
	return value;
}

export function SiteValuationMethodologyList() {
	var value = [];

	var cost = global.ptr.valRpt.approachToValue.costApproach.costApproachDetail;
	if (!cost) return value;
	var val = global.ptr.valuationAnalysis;
	if (cost.siteValuationMethodType !== "SalesComparison") return value;
	if (val.landComparables.comparablePropertyList.length === 0) return value;

	var ix = 1;	
	for(var cp of val.landComparables.comparablePropertyList) {
		//console.log(cp.sales);
		var rels = global.ptr.relationships.GetRelationshipsTo("DATA_SOURCE_IsDataSourceFor_PROPERTY", cp.label);
		var dataSource = val.dataSources.GetDataSource(rels);
		var apn = cp.GetAPNs();
		var size = cp.site.siteSizeLayout.lotSizeAreaMeasure.toString() ?? "";
		var transDate = cp.sales.GetHistoryTransferDate();
		var price = h.amountOrEmpty(cp.sales.GetHistoryTransferAmount());

		var row = [];
		row.push(ix.toString());
		row.push(cp.address.GetFullAddress());
		row.push(cp.address.countyName);
		row.push(dataSource);
		row.push(apn);
		row.push(size);
		row.push(transDate ? transDate.FormatMDY() : "");
		row.push(price);
		value.push(row);

		++ix;
	}
	
	return value;
}

export function DwellingExteriorAttic(dwelling) {
	if (!dwelling.structure) return;
	// 	AtticExistsIndicator
	// 	AccessibleForObservationIndicator
	// 	VisualObservationCompletedIndicator
	var sd = dwelling.structure.structureDetail;
	var exists = sd.atticExistsIndicator;
	if (exists === null) return;

	var accessable = sd.accessibleForObservation;
	var visual = sd.visualObservationCOmletedIndicator;

	if (global.ptr.bGovAgency && !global.ptr.bIsRise) {
		if (!exists ) return "No";
		var gType = global.ptr.govtAppraisalType;
		if (gType === "VA") return "Yes";
		if (["USDA", "FHA"].includes(gType)) {
			if (accessable)
				return visual ? "Visual Observation Completed" : "No Visual Observation Completed";
		}
	}
	return;
}

export function MechanicalSystemDetails(dwelling) {
	var value = [];
	var row;
	var type;
	if (dwelling.system === null) return value;
	if (dwelling.system.heatingSystems.length > 0)
	{
		for (var hs of dwelling.system.heatingSystems) {
			type = hs.GetHeatingType();
			var detail = hs.GetFuelType();
			if (type === "None")
				detail = (dwelling.lackOfHeatingSystemTypicalToMarketIndicator ?? false) ? "Typical for Market" : "Not Typical for Market";

			row = [];
			row.push("Heating");
			row.push(type);
			row.push(detail);
			value.push(row);
		}
	}
	else {
		row = [];
		row.push("Heating");
		row.push("None");
		row.push("");
		value.push(row);
	}

	if (dwelling.system.coolingSystems.length > 0) {
		for (var cs of dwelling.system.coolingSystems) {
			type = cs.GetCoolingType();
			row = [];
			row.push("Cooling");
			row.push(type);
			row.push("");
			value.push(row);
		}
	}
	else {
		row = [];
		row.push("Cooling");
		row.push("None");
		row.push("");
		value.push(row);
	}

	return value;
}

export function LevelDetailList(propertyUnit) {
	var value = [];
	if (propertyUnit.levels.length === 0) return value;
	for (var level of propertyUnit.levels)
	{
		var levelType = level.GetLevelType();
		var levelDetail = level.GetLevelDetail();
		var summary = propertyUnit.GetRoomSummary(level.levelType);

		//console.log(level.levelFinishedAreaMeasure, level.levelUnfinishedAreaMeasure);
		var bFinishedMeasure = level.levelFinishedAreaMeasure.HasValue();
		var bUnfinishedMeasure = level.levelUnfinishedAreaMeasure.HasNonZeroValue();

		var bTwoRows = bFinishedMeasure && bUnfinishedMeasure;

		var finishedMeasure = level.levelFinishedAreaMeasure.toString();
		var unfinishedMeasure = level.levelUnfinishedAreaMeasure.toString();
		//console.log(bFinishedMeasure, bUnfinishedMeasure, bTwoRows);

		var row = [];
		var row0 = [];
		var row1 = [];
		var row2 = [];

		row.push(levelType);
		row.push(levelDetail);

		row0 = [];
		if (!bTwoRows) {
			row1 = [];
			row1.push("Finished");
			row1.push(finishedMeasure);
			row1.push(summary);
			row0.push(row1);
		}
		else {
			row1 = [];
			row2 = [];

			row1.push("Finished");
			row1.push(finishedMeasure);
			row1.push(summary);

			row2.push("Unfinished");
			row2.push(unfinishedMeasure);
			row2.push(" ");

			row0.push(row1);
			row0.push(row2);
			}

		row.push(row0);
		value.push(row)
		}

	return value;
}

export function KitchenAndBathroomDetailsList(propertyUnit) {
	var value = [];
	//console.log(propertyUnit);
	if (propertyUnit.rooms.length === 0) return value;

	// order is Kitchens, Bathrooms
	var roomType = ["Kitchen", "FullBathroom", "HalfBathroom"];
	for (var r of roomType) {
		for (var room of propertyUnit.rooms) {
			var roomDetail = room.roomDetail;
			if (roomDetail.roomType.includes(r)) {
				//console.log(roomDetail.roomType, r);

				var row = [];
				row.push(room.GetRoomTypeLevel());
				row.push(h.toEnumText(roomDetail.roomUpdateStatusType));
				row.push(h.toEnumText(roomDetail.roomUpdatedTimeframeType));
				row.push(roomDetail.roomQualityDescription);
				row.push(h.toEnumText(roomDetail.roomConditionStatusType));
				row.push(roomDetail.roomConditionAdditionalDescription);
				value.push(row);
			}
		}
	}
	return value;
}

export function InteriorFeaturesList(propertyUnit) {
	var value = [];
	var row = null;
	var row0 = null;
	var row1 = null;

	var flooringComponent = propertyUnit.GetComponent("Flooring");
	if (flooringComponent !== null && flooringComponent.floorCoverings.length > 0) {
		row = [];
		var feature = flooringComponent.interiorComponentDetail.improvementComponentType;
		row.push(feature);
		row0 = [];
		for (var covering of flooringComponent.floorCoverings) {
			row1 = [];
			row1.push(h.toEnumText(covering.flooringType));
			row1.push(covering.improvementComponentQualityDescription);
			row1.push(h.toEnumText(covering.improvementComponentConditionStatusType));
			row1.push(covering.improvementComponentConditionDescription);
			row0.push(row1);
		}
		row.push(row0);
		value.push(row);
	}

	var wallsComponent = propertyUnit.GetComponent("WallsAndCeiling");
	if (wallsComponent !== null) {
		var wac = wallsComponent.wallsAndCeiling;
		row = [];
		row.push(wallsComponent.GetComponentType());

		row0 = [];
		row1 = [];
		row1.push(wac.GetDetail());
		row1.push(wallsComponent.interiorComponentDetail.improvementComponentQualityDescription);
		row1.push(wallsComponent.GetComponentStatus());
		row1.push(wallsComponent.interiorComponentDetail.improvementComponentConditionDescription);
		row0.push(row1);

		row.push(row0);
		value.push(row);
	}

	// other components

	var otherComponents = propertyUnit.GetOtherComponents();
	if (otherComponents.length > 0) {
		for (var component of otherComponents) {
			row = [];
			row.push(component.GetComponentType());

			row0 = [];
			row1 = [];
			row1.push(component.interiorComponentDetail.improvementComponentTypeAdditionalDescription);
			row1.push(component.interiorComponentDetail.improvementComponentQualityDescription);
			row1.push(component.GetComponentStatus());
			row1.push(component.interiorComponentDetail.improvementComponentConditionDescription);
			row0.push(row1);

			row.push(row0);
			value.push(row);
		}
	}

	return value;
}

export function AccessibilityFeaturesList(propertyUnit) {
	var value = [];

	var accFeatures = propertyUnit.GetAccessibilityFeaturesList();
	if (accFeatures.length === 0) return value;

	for (var acc of propertyUnit.accessibilityFeatures) {
		var row = [];
		row.push(acc.accessibilityFeatureType);
		row.push(acc.accessibilityModificationDescription);
		value.push(row);
	}
	return value;
}

export function GetRoomSummariesList(outbuilding) {
	var value = [];

	var summary = (outbuilding.interior !== null) ? outbuilding.interior.GetRoomSummaries() : "";
	var propStruct = outbuilding.structure.structureDetail;

	var row = [];
	row.push("Finished");
	row.push(propStruct.structureExcludingVehicleStorageAndADUFinishedAreaMeasure.toString());
	row.push(summary);
	value.push(row);

	row = [];
	row.push("Unfinished");
	row.push(propStruct.structureExcludingVehicleStorageAndADUUnfinishedAreaMeasure.toString());
	row.push("");
	value.push(row);

	return value;

}

export function VehicleStorageList() {
	var value = [];
	//console.log(global.ptr.subProp.carStorages);
	if (global.ptr.subProp.carStorages.carStorageList.length === 0) return undefined;

	for (var car of global.ptr.subProp.carStorages.carStorageList) {
		var row = [];
		row.push(car.GetCarStorageType());
		row.push(car.GetParkingSpacesDetail());
		row.push(car.GetCarStorageDetails());
		value.push(row);
	}

	return value;
}

export function AmenitiesList() {
	var value = [];
	if (global.ptr.subProp.propertyAmenity === null) return value;
	if (global.ptr.subProp.propertyAmenity.amenityCategories.length === 0) return value;

	let mfg = false;
	let ctype = global.ptr.subProp.GetConstructionMethods();
	mfg |= ctype.includes("Manufactured")

	for (var category of global.ptr.subProp.propertyAmenity.amenityCategories) {
		//console.log("cat: ", category);
		var type = category.amenityCategoryDetail.amenityCategoryType;
		var row0 = [];
		row0.push(category.GetAmenityCategoryType());

		var row1 = [];
		if (category.amenities.length === 1) {
			var am0 = category.amenities[0];
			// only one sub-row
			row0.push(am0.GetAmenityType());
			row0.push(am0.GetMaterialType());
			row0.push(am0.GetAmenityDetails(type));
			//row0.push(row1);
		}
		else {
			for (var amenity of category.amenities) {
				var row2 = [];
				row2.push(amenity.GetAmenityType());
				row2.push(amenity.GetMaterialType());
				row2.push(amenity.GetAmenityDetails(type, mfg));
				row1.push(row2);
			}
			row0.push(row1);
		}
		value.push(row0);

	};

	return value;
}

export function GetAmenityDefects() {
	let defects = [];
	if (!global.ptr.subDetail.subjectPropertyAmenitiesDefectsExistIndicator) return [];
	var ftList = global.ptr.relationships.GetRelationshipsByArcFromTo("DEFECT_ContainsDefectOf_AMENITY");

	ftList.forEach(ft => {
		let defect = global.ptr.subProp.propertyDefect.GetDefectByLabel(ft.from);
		defects.push(defect);
	})

	return defects;
}


export function AmenitiesDefectsRowsList() {
	let value = [];
	if (!global.ptr.subDetail.subjectPropertyAmenitiesDefectsExistIndicator) return [];

	let defects = GetAmenityDefects();
	defects.forEach(defect => {
		var row = GetAmenityDefectRow(defect);
		value.push(row);
	})

	return value;
}


export function VehicleDefectsList() {
	if (!(global.ptr.subDetail.vehicleStorageDefectsExistIndicator ?? false)) return [];
	var defects = DefectsList("DEFECT_ContainsDefectOf_CAR_STORAGE", global.ptr.subProp.label);
	return defects;
}

export function SiteDefectsList() {
	if (!(global.ptr.subSite.siteDetail.siteDefectsExistIndicator ?? false)) return [];
	var defects = DefectsList("DEFECT_ContainsDefectOf_SITE", global.ptr.subProp.label);
	return defects;
}
export function ImprovementDefectsList(dwelling) {
	// dwelling could be an outbuilding
	if (!((dwelling.improvementDetail.dwellingExteriorDefectsExistIndicator ?? false) ||
			(dwelling.improvementDetail.outbuildingDefectsExistIndicator ?? false))) return [];

	var defects = DefectsList("DEFECT_ContainsDefectOf_IMPROVEMENT", dwelling.label);
	return defects;
}

export function UnitDefectsList(propertyUnit) {
	if (global.ptr.subProp.propertyDefect === null) return [];
	var defects = DefectsList("DEFECT_ContainsDefectOf_PROPERTY_UNIT", propertyUnit.label);
	return defects;
}

function DefectsList(relationship, label) {
	var value = [];
	if (global.ptr.subProp.propertyDefect === null) return [];
	var defects = global.ptr.subProp.propertyDefect.GetDefectsByArcRole(relationship, label);
	for (var defect of defects) {
		//defectImages.AddRange(defect.GetImages());
		value.push(GetDefectRow(defect));
	}
	return value;
}
	
function GetDefectRow(defect) {
	var row = [];

	row.push(defect.GetComponentLabelType());
	row.push(defect.GetLocationType());
	row.push(defect.defectDetail.defectItemDescription);
	row.push(h.yesNo(defect.defectDetail.defectItemAffectsSoundnessStructuralIntegrityIndicator));
	row.push(h.toEnumText(defect.defectDetail.defectItemRecommendedActionType));
	row.push(defect.defectDetail.defectItemEstimatedCostToRepairAmount.ToDollarAmount());
	return row;
}

export function GetAmenityDefectRow(defect) {

	var label = defect.label;
	var rels = global.ptr.relationships.GetRelationshipsFrom("DEFECT_ContainsDefectOf_AMENITY", label);
	var amenity = global.ptr.subProp.GetAmenityByLabel(rels[0]);

	var feature = amenity.GetAmenityType();
	var location = defect.GetLocationType();
	var descr = defect.defectDetail.defectItemDescription;
	var soundness = h.yesNo(defect.defectDetail.defectItemAffectsSoundnessStructuralIntegrityIndicator)
	var action = h.toEnumText(defect.defectDetail.defectItemRecommendedActionType);
	var cost = h.amountOrEmpty(defect.defectDetail.defectItemEstimatedCostToRepairAmount);
	if (cost) cost = ">" + cost;

	return [feature, location, descr, soundness, action, cost];
}

export function OverallQualityConditionList() {
	var value = [];

	for (var improvement of global.ptr.subDwellingList) {
		// for each structure
		var bldgName = improvement.structure.structureDetail.structureIdentifier;
		if (!h.isEmpty(bldgName)) bldgName = " - " + bldgName;

		var row = [];
		var rowq = [];
		var rowc = [];

		var q = improvement.structure.structureDetail.exteriorQualityRatingCode;
		var c = improvement.structure.structureDetail.exteriorConditionRatingCode;
		if (global.ptr.subDetail.homeownerResponsibleForExteriorMaintenanceIndicator ?? false) {
			rowq.push("E" + bldgName + "-" + q);
			rowc.push("E" + bldgName + "-" + c);
		}

		for (var unit of improvement.propertyUnits) {
			var unitDetail = unit.propertyUnitDetail;
			if (unitDetail.accessoryDwellingUnitIndicator ?? false) continue;	// skip ADUs

			// var unitName = "";
			if (global.ptr.subDetail.livingUnitExcludingADUCount > 1)
			var unitName = unitDetail.unitIdentifier;

			var uq = unitDetail.interiorQualityRatingCode;
			var uc = unitDetail.interiorConditionRatingCode;
			rowq.push("I-" + unitName + "-" + uq);
			rowc.push("I-" + unitName + "-" + uc);
		}
		row.push(rowq);
		row.push(rowc);
		value.push(row);
	}

	return value;
}

export function OverallQualityList() {
	var value = [];
	//var bldgCount = global.ptr.subDwellingList.length;
	var bldgName = null;
	var unitName = null;

	for (var improvement of global.ptr.subDwellingList) {
		// for each structure
		bldgName = improvement.structure.structureDetail.structureIdentifier;
		if (!h.isEmpty(bldgName)) bldgName = " - " + bldgName;

		var row0 = [];

		var row1 = [];
		var q = improvement.structure.structureDetail.exteriorQualityRatingCode;
		if (global.ptr.subDetail.homeownerResponsibleForExteriorMaintenanceIndicator ?? false) {
			row1.push("Exterior Quality - " + bldgName);
			row1.push(q);
		} else {
			row1.push("");
			row1.push("");
		}
		row0.push(row1);

		//var dwellingUnitCount = improvement.propertyUnits.length;

		row1 = [];
		for (var unit of improvement.propertyUnits) {
			var unitDetail = unit.propertyUnitDetail;
			if (unitDetail.accessoryDwellingUnitIndicator ?? false) continue;	// skip ADUs

			unitName = "Interior Quality";
			if (global.ptr.subDetail.livingUnitExcludingADUCount > 1)
				unitName += " - " + unitDetail.unitIdentifier;

			var iq = unitDetail.interiorQualityRatingCode;

			var row2 = [];
			row2.push(unitName);
			row2.push(iq);
			row1.push(row2);
		}
		row0.push(row1);
		value.push(row0);
	}

	return value;
}

export function OverallConditionList() {
	var value = [];
	//var bldgCount = global.ptr.subDwellingList.length;
	var bldgName = null;
	var unitName = null;

	for (var improvement of global.ptr.subDwellingList) {
		// for each structure
		bldgName = improvement.structure.structureDetail.structureIdentifier;
		if (!h.isEmpty(bldgName)) bldgName = " - " + bldgName;

		var row0 = [];

		var row1 = [];
		var q = improvement.structure.structureDetail.exteriorConditionRatingCode;
		if (global.ptr.subDetail.homeownerResponsibleForExteriorMaintenanceIndicator ?? false) {
			row1.push("Exterior Condition - " + bldgName);
			row1.push(q);
		} else {
			row1.push("");
			row1.push("");
		}
		row0.push(row1);

		//var dwellingUnitCount = improvement.propertyUnits.length;

		row1 = [];
		for (var unit of improvement.propertyUnits) {
			var unitDetail = unit.propertyUnitDetail;
			if (unitDetail.accessoryDwellingUnitIndicator ?? false) continue;	// skip ADUs

			unitName = "Interior Condition";
			if (global.ptr.subDetail.livingUnitExcludingADUCount > 1)
				unitName += " - " + unitDetail.unitIdentifier;

			var iq = unitDetail.interiorConditionRatingCode;

			var row2 = [];
			row2.push(unitName);
			row2.push(iq);
			row1.push(row2);
		}
		row0.push(row1);
		value.push(row0);
	}

	return value;
}

// ********************************************************************
// below is data collection for the project financing table
// ********************************************************************

var lienDetail = [
		"Unpaid Principal Balance",
		"Line of Credit",
		"Balloon Mortgage",
		"Remaining Term",
		"Monthly Payment",
		"Interest Rate",
		"Amortization Type",
		"Pro Rata Share of Balance Attributable to Unit"
];

var lienTitles = [
	"Lien Detail",
	"First Lien",
	"Second Lien",
	"Third Lien",
	"Fourth Lien"
];

export function GetProjectFinancingTitles() {

	var titles = [];
	var len = global.ptr.subProj.projectBlanketFinancings.length;
	for ( var i = 0; i <= len; ++i)
		titles.push(lienTitles[i]);
	return titles;
}

export function GetProjectFinancing() {
	var list = [];
	var pbf = global.ptr.subProj.projectBlanketFinancings;

	for (var ld of lienDetail) {
		var row = [ ];
		row.push(ld);
		var k = 0;
		for (var p of pbf) {
				k = k + 1;
				var temp = "";
				var bLOC = p.lineOfCreditIndicator ?? false;
				switch (ld) {
					case "Unpaid Principal Balance":
							row.push(!bLOC ? p.UPBAmount.toString() : "");
							break;
					case "Line of Credit":
							if (bLOC) {
									temp = "Maximum: " + p.lineOfCreditMaximumAmount.toString();
									row.push(h.addWithNewline(temp, "Drawn: " + p.lineOfCreditDrawnAmount.toString()));
							} else {
								row.push("");
							}
							break;
					case "Balloon Mortgage":
							row.push(h.yesNo(p.balloonIndicator));
							break;
					case "Remaining Term":
							row.push(p.loanRemainingMaturityTermMonthsCount + " months");
							break;
					case "Monthly Payment":
							row.push(p.paymentAmountAvailableIndicator ?? false ? p.totalPaymentAmount.toString() : "Unknown");
							break;
					case "Interest Rate":
							row.push(p.interestRateAvailableIndicator ?? false ? p.currentInterestRatePercent : "Unknown");
							break;
					case "Amortization Type":
							row.push(p.GetAmortizationType());
							break;
					case "Pro Rata Share of Balance Attributable to Unit":
							if (!bLOC)
									row.push(p.UPBProRataShareAttributableToUnitAmount.toString());
							else {
									temp = "Maximum: " + p.lineOfCreditMaximumProRataShareAttributableToUnitAmount.toString();
									row.push(h.addWithNewline(temp, "Drawn: " + p.lineOfCreditDrawnProRataShareAttributableToUnitAmount.toString()));
							}
							break;
					default:
						break;
				}
			}
		list.push(row);
	}
	return list;
}

export function ProjectFactorsList() {

	var subProp = global.ptr.subProp;
	var subProj = global.ptr.subProj;
	var projFin = subProj.projectFinancialInformation;
	var valRpt = global.ptr.valRpt;
	var bInProject = global.ptr.bInProject;
	var bCondominium = global.ptr.bCondominium;
	var bCooperative = global.ptr.bCooperative;
	var bCondop = global.ptr.bCondop;
	var bCompleted = global.ptr.subProj.projectCompletedIndicator ?? false;
	var bConversion = global.ptr.subProj.projectConversion?.projectConversionIndicator ?? false;
	var bInControl = global.ptr.subProj.projectDeveloperOrSponsorControlsProjectManagementIndicator ?? false;

	var value = [];

	var row = [];
	row.push("Developer/Sponsor in Control");
	row.push(h.yesNo(bInControl));
	row.push("");
	row.push("");
	var commentary = valRpt.GetValuationCommentary("ProjectDeveloperOrSponsorControlsProjectManagement");
	if (commentary !== null)	{
		row[2] = h.toEnumText(commentary.valueMarketabilityImpactType);
		if (!bInControl && (row[2] === "Adverse" || row[2] === "Beneficial" || row[2] === "Neutral"))
			row[3] = commentary.valuationCommentText;
	}
	value.push(row);

	if (bInProject && !bCompleted)
	{
		commentary = valRpt.GetValuationCommentary("IncompleteProject");

		row = [];
		row.push("Incomplete Project");
		row.push(subProj.GetComponentTypes());
		row.push(commentary ? h.toEnumText(commentary.valueMarketabilityImpactType) : "");
		row.push(commentary ? commentary.valuationCommentText : "");
		value.push(row);
	}

	if (bInProject && bConversion)
	{
		commentary = valRpt.GetValuationCommentary("ProjectConversion");

		row = [];
		row.push("Converted in Past 3 Years");
		row.push(h.toEnumText(subProj.projectConversion.projectConversionOriginalUseType));
		row.push(commentary ? h.toEnumText(commentary.valueMarketabilityImpactType) : "");
		row.push(commentary ? commentary.valuationCommentText : "");
		value.push(row);
	}

	if (bCondominium)
	{
		commentary = valRpt.GetValuationCommentary("SingleEntityGreatestNumberOfUnitsOwned");

		row = [];
		row.push("Single Entity Ownership of Multiple Units");
		row.push("Greatest Number of Units Owned - " + projFin.singleEntityGreatestNumberOfUnitsCount);
		row.push(commentary ? h.toEnumText(commentary.valueMarketabilityImpactType) : "");
		row.push(commentary ? commentary.valuationCommentText : "");
		value.push(row);
	}

	if (bCooperative || bCondop)
	{
		commentary = valRpt.GetValuationCommentary("SingleEntityGreatestNumberOfSharesOwned");

		row = [];
		row.push("Single Entity Ownership of Multiple Shares");
		row.push("Greatest Number of Shares Owned - " + projFin.singleEntityGreatestNumberOfSharesCount);
		row.push(commentary ? h.toEnumText(commentary.valueMarketabilityImpactType) : "");
		row.push(commentary ? commentary.valuationCommentText : "");
		value.push(row);
	}

	if (bInProject)
	{
		commentary = valRpt.GetValuationCommentary("ProjectCommercialSpace");
		var bSpace = subProj.projectCommercialSpaceIndicator ?? false;

		row = [];
		row.push("Commercial Space");
		row.push(bSpace ? subProj.projectCommercialSpacePercent : "None");
		row.push(commentary ? h.toEnumText(commentary.valueMarketabilityImpactType) : "");
		row.push(commentary ? commentary.valuationCommentText : "");
		value.push(row);
	}

	commentary = valRpt.GetValuationCommentary("ProjectLegalAction");

	row = [];
	row.push("Known Legal Actions");
	row.push((subProj.legalActionIndicator ?? false) ? "" : "None");
	row.push(commentary ? h.toEnumText(commentary.valueMarketabilityImpactType) : "");
	row.push(commentary ? commentary.valuationCommentText : "");
	value.push(row);

	if (bInProject)
	{
		commentary = valRpt.GetValuationCommentary("TransferFeeAttributedToSubjectProperty");
		//var bTransferFee = subProp.homeownersAssociations.GetOwnershipTransferFeeIndicator();
		var charges = subProp.homeownersAssociations.GetAssociationCharges("OwnershipTransferFee");

		row = [];
		row.push("Unit Transfer Fees");
		row.push((charges.length > 0) ? charges[0].associationChargeDetail.associationChargeAmount.toString() : "None");
		row.push(commentary ? h.toEnumText(commentary.valueMarketabilityImpactType) : "");
		row.push(commentary ? commentary.valuationCommentText : "");
		value.push(row);
	}

	var assCharges = subProp.homeownersAssociations.GetAssociationCharges("AssociationSpecialAssessment");
	// collect amounts
	var detail = "";
	for(var charge of assCharges)
	{
		if (!charge.associationChargeDetail.associationSpecialAssessmentStatusType === "None") {
			var chg = charge.GetStatusType();
			var chgAmt = (charge.associationChargeDetail.associationChargeBalanceAmount ?? 0);
			if (chgAmt > 0) chg += " " + chgAmt.toString();
			detail = detail.addWithNewline(chg);
		}
	}

	commentary = valRpt.GetValuationCommentary("ProjectSpecialAssessmentsAttributedToSubjectProperty");
	
	row = [];
	row.push("Unit Special Assessments");
	row.push(detail.length > 0 ? detail : "None");
	row.push(commentary ? h.toEnumText(commentary.valueMarketabilityImpactType) : "");
	row.push(commentary ? commentary.valuationCommentText : "");
	value.push(row);

	detail = "";
	var bExemption = subProp.propertyTaxes.propertyTaxDetail.propertyTaxAbatementsOrExemptionsIndicator ?? false;
	if (bExemption) {
		detail = subProp.propertyTaxes.GetAbatementAnnualAmount();
		detail = h.addWithNewline(detail, "Expires: " + subProp.propertyTaxes.GetAbatementExpirationDate());
	}

	commentary = valRpt.GetValuationCommentary("PropertyTaxAbatementsOrExemptions");

	row = [];
	row.push("Unit Tax Abatements or Exemptions");
	row.push(bExemption ? detail : "None");
	row.push(commentary ? h.toEnumText(commentary.valueMarketabilityImpactType) : "");
	row.push(commentary ? commentary.valuationCommentText : "");
	value.push(row);

	return value;
}

export function ListingInformationDOMTotal() {
	var bListed = global.ptr.subProp.listingInformationSummary.listedWithinPreviousYearIndicator ?? false;
	var infos = global.ptr.subProp.listingInformations;
	if (!bListed || infos.length === 0) return undefined;

	var domTotal = 0;
	for (var listing of infos) {
		domTotal += Number(listing.listingInformationDetail.daysOnMarketCount);
	}

	return domTotal;
}

export function ListingInformationList() {
	var value = [];

	var bListed = global.ptr.subProp.listingInformationSummary.listedWithinPreviousYearIndicator ?? false;
	var infos = global.ptr.subProp.listingInformations;
	if (!bListed || infos.lentgh === 0) return value;

	for (var listing of infos) {
		var row = [];
		var listDetail = listing.listingInformationDetail;
		row.push(listing.GetListingStatusType());
		row.push(listing.GetListingType());
		row.push(listDetail.listingIdentifier);
		row.push(listDetail.listingStartDate.FormatMDY());
		row.push(listDetail.listingEndDate.FormatMDY());
		row.push(listDetail.daysOnMarketCount.toString());
		row.push(listDetail.initialListPriceAmount.ToDollarAmount());
		row.push(listDetail.finalListPriceAmount.ToDollarAmount());
		value.push(row);
	}

	return value;
}

export function SubjectTransferHistoryList() {
	var value = [];

	for (var sh of global.ptr.subSales.salesHistories) {
		var terms = sh.GetOwnershipTransferType();
		if (sh.ownershipTransferTransactionType === "Sale")
			terms = sh.GetSaleType();
		var amount = (sh.ownershipTransferTransactionAmount.HasValue()) ? sh.ownershipTransferTransactionAmount.ToDollarAmount() : sh.GetAmountNotAvailableReason();

		var source = "";
		var rels = global.ptr.relationships.GetRelationshipsTo("DATA_SOURCE_IsDataSourceFor_SALES_HISTORY", sh.label);
		for (var rel of rels)
			source = h.addWithNewline(source, global.ptr.valuationAnalysis.dataSources.GetDataSourceType(rel));

		var row = [];
		row.push(terms);
		row.push(sh.ownershipTransferDate.FormatMDY());
		row.push(amount);
		row.push(source);
		value.push(row);
	}

	return value;
}

export function ComparableTransferHistoryList() {
	var value = [];

	var comps = global.ptr.valuationAnalysis.salesComparables;
	var index = 0;
	for (const cp of comps.comparablePropertyList) {
		index += 1;
		const cpLabel = cp.propertyDetail.priorSalesOrTransfersLabel;

		var row0 = [];
		row0.push(index.toString());
		var row1 = [];
		if (cp.sales.salesHistories.length > 0) {
			var transferFound = false;
			for (const history of cp.sales.salesHistories) {
				var label = history.label;
				if (!h.isEmpty(label)) {
					var disclosed = history.GetAmountNotAvailableReason();
					if (disclosed)
						var amtDisplay = disclosed;
					else
						var amtDisplay = history.ownershipTransferTransactionAmount.ToDollarAmount();

					var sources = GetDataSources("DATA_SOURCE_IsDataSourceFor_SALES_HISTORY", label);

					var row2 = [];
					row2.push(history.GetSaleType());
					row2.push(history.ownershipTransferDate.FormatMDY());
					row2.push(amtDisplay);
					row2.push(sources);
					row1.push(row2);
					transferFound = true;
				}
			}
			if (!transferFound) {
				var sources = GetDataSources("DATA_SOURCE_IsDataSourceFor_PriorSalesOrTransfersIndicator", cpLabel);
				var row2 = [];
				row2.push("None");
				row2.push("");
				row2.push("");
				row2.push(sources);
				row1.push(row2);
			}
		row0.push(row1); 
		} else {
			var sources = GetDataSources("DATA_SOURCE_IsDataSourceFor_PriorSalesOrTransfersIndicator", cpLabel);
			var row1 = [];
			var row2 = [];
			row2.push("None");
			row2.push("");
			row2.push("");
			row2.push(sources);
			row1.push(row2);
			row0.push(row1); 
		}
		
		value.push(row0);
	}

	return value;
}

export function ReconAPV() {
	let list = [];


	let apv = global.ptr.valRpt.approachToValue;
	let row1 = [];
	row1.push("Indicated Value");
	row1.push(apv.GetSalesComparisonApproachIndicatedValue());
	row1.push(apv.GetIncomeApproachIndicatedValue());
	row1.push(apv.GetCostApproachIndicatedValue());
	list.push(row1);

	row1 = [];
	row1.push("Reason for Exclusion");
	row1.push("");
	row1.push(apv.incomeApproach.GetExclusionReasons());
	row1.push(apv.costApproach.GetExclusionReasons());
	list.push(row1);

	return list;
}

export function ClientRequestedConditionsList() {
	let list = [];

	let conds = global.ptr.valRecon.additionalRequestedConditionalValuations;
	if (conds.length === 0) return list;

	conds.forEach(c => {
		let row1 = [];
		row1.push(h.toEnumText(c.propertyValuationConditionalConclusionType));
		row1.push(h.toEnumText(c.marketingOrExposureTimeType));
		row1.push(c.GetExposureTime());
		row1.push(c.additionalOpinionOfValueAmount.ToDollarAmount());
		list.push(row1);
	})

	return list;
}

export function GetRevisionHistory() {
	let list = [];
	if (global.ptr.valRpt.valuationRevisions.length === 0) return list;

	global.ptr.valRpt.valuationRevisions.forEach(vr => {
		let row1 = [];
		row1.push(vr.revisionDate.FormatMDY());
		row1.push(h.toEnumText(vr.revisionCategoryType));
		row1.push(vr.revisionText);
		list.push(row1);
	})

	return list;
}

export function GetCertifcationNames() {
	let names = "";
	let roleParties = global.ptr.parties.GetPartiesOfRole("SignificantRealPropertyAppraisalAssistance");
	if (roleParties.length === 0) return "";
		roleParties.forEach (p => {
		names = h.addWithSpacer(names, p.GetName(), " and ");

		})
		return names;
}

export function GetAdditionalCertifications() {
	let list = [];

	let certs = global.ptr.sow.GetAdditionalCertifications("Appraiser");
	let index = 0;
	certs.forEach(cert => {
		++index;
		let iStr = index.toString();
		let title = iStr + ". ";
		title += cert.valuationAdditionalCertificationText;
		list.push(title);
	})

	return list;
}

export function GetAdditionalSupervisorCertifications() {
	let list = [];

	let certs = global.ptr.sow.GetAdditionalCertifications("AppraiserSupervisor");
	let index = 0;
	certs.forEach(cert => {
		++index;
		let iStr = index.toString();
		let title = iStr + ". ";
		title += cert.valuationAdditionalCertificationText;
		list.push(title);
	})
	
	return list;
}

export function GetSignatories() {
	let list = [];

	let rels = global.ptr.relationships.GetRelationshipsByRole("SIGNATORY_IsAssociatedWith_ROLE");
	rels.forEach(r => {
		let sig = global.ptr.signatories.GetSignatoryByLabel(r.from);
		let party = global.ptr.parties.GetPartyByRoleLabel(r.to);
		let role = global.ptr.parties.GetRoleByRoleLabel(r.to);

		let date = sig.executionDate.FormatMDY();
		let roleType = role.GetRoleType();
		let name = party.GetName();
    let lic = party.GetLicense();
		let license = null;
		if (lic) {
			let level = lic.GetLicenseType();
			let id = lic.licenseDetail.licenseIdentifier;
			let state = lic.licenseDetail.licenseIssuingAuthorityStateCode;
			let expDate = lic.licenseDetail.licenseExpirationDate.FormatMDY();

			license = {
				level: level,
				id: id,
				state: state,
				date: expDate
			}
		}

		let signer = {
			role: roleType,
			name: name,
			date: date,
			license: license
		};

		list.push(signer);
	})

	return list;
}

export function DwellingExteriorExhibits(dwelling) {
	let images = global.ptr.subProp.GetImagesByCategories(["NoncontinuousArea","DwellingRear","DwellingExteriorExhibit"]);

	if (global.ptr.subProp.propertyDefect !== null) {
		var defects = global.ptr.subProp.propertyDefect.GetDefectsByArcRole("DEFECT_ContainsDefectOf_IMPROVEMENT", dwelling.label);
		if (defects.length > 0) {
			defects.forEach(defect => {
				images.push(...defect.GetImages());
			})
		}
	}

	return images;
}

export function UnitInteriorExhibitImages(propertyUnit) {
	let unitImages = [];
	unitImages.push(...propertyUnit.GetRoomImages());

	if (global.ptr.subProp.propertyDefect !== null) {
		var defects = global.ptr.subProp.propertyDefect.GetDefectsByArcRole("DEFECT_ContainsDefectOf_PROPERTY_UNIT", propertyUnit.label);
		let defectImages = [];
		if (defects.length > 0) {
			defects.forEach(defect => {
				defectImages.push(...defect.GetImages());
			})
		}
		unitImages.push(...defectImages);
	}

	unitImages.push(...global.ptr.subProp.GetImagesByCategory("UnitInteriorExhibit"));

	return unitImages;
}

export function OutbuildingExhibits(dwelling) {
	let images = [];

	if (global.ptr.subProp.propertyDefect !== null) {
		var defects = global.ptr.subProp.propertyDefect.GetDefectsByArcRole("DEFECT_ContainsDefectOf_IMPROVEMENT", dwelling.label);
		if (defects.length > 0) {
			defects.forEach(defect => {
				images.push(...defect.GetImages());
			})
		}
	}

	images.push(...global.ptr.subProp.GetImagesByCategory("OutbuildingExhibit"));
	return images;
}

export function VehicleStorageExhibits() {
	let images = [];
	
	images.push(...global.ptr.subProp.carStorages.GetCarStorageImages());

	global.ptr.subProp.carStorages.carStorageList.forEach(cs => {
		if (cs.label) {
			var defects = global.ptr.subProp.propertyDefect.GetDefectsByArcRole("DEFECT_ContainsDefectOf_CAR_STORAGE", cs.label);
			if (defects.length > 0) {
				defects.forEach(defect => {
					images.push(...defect.GetImages());
				})
			}
		}
	})

	images.push(...global.ptr.subProp.GetImagesByCategory("VehicleStorageExhibit"));
	return images;
}

export function SubjectPropertyAmenityExhibits() {
	let images = global.ptr.subProp.GetAmenityImages();	

	let defects = GetAmenityDefects();
	if (defects.length > 0) {
		defects.forEach(defect => {
			images.push(...defect.GetImages());
		})
	}

	images.push(...global.ptr.subProp.GetImagesByCategory("SubjectPropertyAmenityExhibit"));
	return images;
}

export function MarketAnalysisExhibits() {
	let images = [];
	let mImages = global.ptr.subProp.GetImagesByCategories(["AbsorbtionRateGraph","MedianDaysOnMarketGraph","PercentOfDistressesSalesGraph","PriceTrendGraph","YearBuldOfSalesGraph"]);

	images.push(...mImages);
	images.push(...global.ptr.subProp.GetImagesByCategory("MarketAnalysisExhibit"));

	return images;
}

export function SalesComparisonApproachExhibits() {
	let images = [];
	
	let scImages = scf.GetCompImages();
	for (let ix = 2; ix < scImages.length; ++ix) {
		let img = scImages[ix];
		img.imageSourceCaption = "Comparable #" + (ix-1).toString();
		images.push(img);

	}
	images.push(...global.ptr.subProp.GetImagesByCategory("SalesComparisonApproach"));
	return images;
}

export function IncomeApproachExhibits() {
	let images = [];
	images.push(...global.ptr.subProp.GetImagesByCategory("GrossRentMultiplierComparableMap"));
	
	let ix = 1;
	global.ptr.compMultList.forEach(cm => {
		let cmImage = cm.GetImageByCategory("PropertyPhoto");
		cmImage.imageSourceCaption = "Comparable #" + (ix).toString();
		images.push(cmImage);
		++ix;
	});
	
	// other stuff
	images.push(...global.ptr.subProp.GetImagesByCategory("IncomeApproachExhibit"));

	return images;
}

